export { UniversityIcon } from './UniversityIcon'
